let _navigate;

export const injectNavigator = (navigate) => {
  _navigate = navigate;
};

export const navigateTo = (...args) => _navigate?.(...args);
